import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  MainService
} from '../../services/main-service.service';
import {
  trigger,
  transition,
  animate,
  style
} from '@angular/animations';

import {
  DatePipe, Location
} from '@angular/common';
import {
  Router,
  ActivatedRoute,
  NavigationEnd
} from '@angular/router';
import {
  ProposalService
} from 'src/app/services/proposal/proposal.service';
import { PaymentComponent } from './payment/payment.component';
import { PersonalComponent } from './personal/personal.component';

@Component({
  selector: 'app-patient-details',
  templateUrl: './patient-details.component.html',
  styleUrls: ['./patient-details.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({
          opacity: 0
        }),
        animate('2s ease-out', style({
          opacity: 1
        }))
      ])
    ])
  ]
})
export class PatientDetailsComponent implements OnInit {
  settingsData: any;
  queryParams: any;
  errorMessage: any;
  loader: boolean;
  invalidLink: boolean;
  patientData: any = {};
  financeData: any = {};
  step: any;
  token: any;
  child: any;
  LABEL; any;
  contract_type: any;
  @ViewChild(PaymentComponent) paymentComponent: PaymentComponent;
  @ViewChild(PersonalComponent) personalComponent: PersonalComponent;
  constructor(public mainService: MainService, private route: ActivatedRoute,
    public proposal: ProposalService, public router: Router, private datePipe: DatePipe, public location: Location) {
    this.child = this.route.children[0];
    this.token = this.child.params.value.token;
    this.mainService.init().subscribe((data: any) => {
      // this.settingsData = data;
      this.mainService.setLoader(false);
      console.log("Customer Details Component Started");
    });
    this.LABEL = this.mainService.LABEL;
    if (this.token) {
      // this.mainService.setLoader(false);
      this.step = 1;
      this.invalidLink = false;
      this.proposal.setToken(this.token);
      this.checkToken(this.token);
    } else {
      this.invalidLink = true;
      this.mainService.setLoader(true);
      this.router.navigate(['/invalid']);
    }
    if (sessionStorage.getItem('contractType')) {
      this.contract_type = JSON.parse(sessionStorage.getItem('contractType'));
    }
    this.router.events
      .subscribe((val: any) => {
        if (val instanceof NavigationEnd) {
          if (val.url.indexOf('personal') > -1) {
            this.step = 1;
          } else if (val.url.indexOf('payment') > -1) {
            this.step = 2;
          }
        }
      });
    }

  ngOnInit() {
  }

  goBack() {
    if (this.step == 1){
      this.router.navigateByUrl("/plans/" + this.token);
    } else {
      this.goToStep(1);
    }
    
  }

  checkToken(token: any) {
    const params = {
      contract_token: token,
      timezone: this.mainService.getCurrentTimezone()
    };
    // this.mainService.setLoader(true);
    this.errorMessage = '';
    this.proposal
      .api(
        'post',
        'check_email_code_apf',
        this.mainService.urlParams(params)
      )
      .subscribe(
        (data: any) => {
          this.mainService.setLoader(false);
          if (data.is_error) {
            this.errorMessage = data.err;
            this.invalidLink = true;
            this.mainService.setLoader(true);
            this.router.navigate(['/invalid']);
          } else {
            this.invalidLink = false;
            this.patientData = data.patients[0];
            this.financeData = data.financing_info[0];
            this.financeData.recurring_amount = parseFloat(this.financeData.recurring_amount);
            if (data.feature_list && data.feature_list.length) {
              this.mainService.featureList = data.feature_list;
            }
            if (!this.financeData.threshold_amount) {
              let matched_plan = JSON.parse(data.split_request_data[0].plans_array)
              if (matched_plan.length > 0) {
                matched_plan = matched_plan.filter(plan => JSON.parse(plan.month) === this.financeData.number_of_payments)
              }
              if (matched_plan.length > 0) {
                this.financeData.recurring_extra_amount = matched_plan[0].recurring_extra_amount;
                this.financeData.recurring_extra_percent = matched_plan[0].recurring_extra_percent;
                this.financeData.threshold_amount = matched_plan[0].threshold_amount;
                this.financeData.threshold_recurring_extra_amount = matched_plan[0].threshold_recurring_extra_amount;
                this.financeData.threshold_recurring_extra_percent = matched_plan[0].threshold_recurring_extra_percent;
                this.financeData.advance_interest_amount = parseFloat(matched_plan[0].advance_interest_amount);
              }
            }
           
            this.proposal.sendData(data);
            sessionStorage.setItem( 'savedPatientData', JSON.stringify(this.patientData));
            sessionStorage.setItem( 'savedFinData', JSON.stringify(this.financeData));
            
            localStorage.setItem( 'savedPatientData', JSON.stringify(this.patientData));
            localStorage.setItem( 'savedFinData', JSON.stringify(this.financeData));
          }
        },
        (err: any) => {
          this.mainService.setLoader(false);
          this.errorMessage = err.error;
        }
      );
  }
  updatePatientData(patientData: any) {
    patientData.patient_mobile = '+1-' + patientData.patient_mobile.replace(/[^0-9]/g, '');
    patientData.employer_mobile = '+1-' + patientData.employer_mobile.replace(/[^0-9]/g, '');
    patientData.date_of_birth = this.datePipe.transform(patientData.dob, 'MM/dd/yyyy');
    const patient = {
      personal: patientData,
      finance: this.financeData
    };
    this.proposal.setPatientData(patient);
    this.mainService.setLoader(true);
    this.router.navigateByUrl('/customer/payment/' + this.token);
    this.step = 2;
    setTimeout(() => {
      this.paymentComponent.ngAfterViewInit();
    }, 500);
  }
  goToStep(step: any) {
    // this.mainService.setLoader(true);
    if (step === 2) {
      const check = this.personalComponent.checkPatientData();
      console.log(check);
      if (check === false) {
        return false;
      } else if (check === true) {
        this.router.navigateByUrl('/customer/payment/' + this.token);
        this.step = step;
      }
    } else {
      this.personalComponent.setPatientData();
      this.router.navigateByUrl('/customer/personal/' + this.token);
      this.step = step;
    }
  }

}
